import { ReactNode } from 'react';
import classNames from 'classnames';

type TProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Canonical wrapper for a single tab's main-area content on item detail pages
 * (Home / History / Approvals / Assessments / etc.). Provides consistent
 * padding, scrolling and full-height/width behaviour across every tab in every
 * item type so switching tabs never causes a layout shift.
 *
 * Use this instead of repeating the `h-full w-full overflow-y-auto py-6 px-1`
 * class string across tab components.
 */
const TabContent = ({ children, className }: TProps) => (
  <div className={classNames('h-full w-full overflow-y-auto py-6 px-1', className)}>{children}</div>
);

export { TabContent };
